// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-favorites[data-v-74dce0f4]{padding:2em;text-align:center;color:var(--color-text-light)}\n", ""]);
// Exports
module.exports = exports;
